import React from "react";
import useSwConfigData from "../../../customHooks/useSwConfigData";
import { SwConfigQueryType } from "../../modules/asset/masters/items/configurations/queries/type";
import useSwConfigVars from "../../../customHooks/useSwConfigs";
import {
  SwConfigBannerType,
  SwConfigStrValueType,
} from "../../modules/asset/users/ResetUserPassword/queries/types";

const Banner = () => {
  const { configData } = useSwConfigVars({
    queryType: SwConfigQueryType.BY_CONFIG_KEY,
    strValue: [SwConfigBannerType.BANNER],
    intValue: 0,
  });

  const handleBannerData = () => {
    let banner = "";

    if (configData && configData.data) {
      const bannerData = configData.data.GetSwConfigVariables;
      if (bannerData && bannerData.length > 0) {
        const bannerItem = bannerData.find(
          (item) => item.configKey === SwConfigBannerType.BANNER
        );
        if (bannerItem && bannerItem.booleanValue) {
          banner = bannerItem.str1Value || "";
        }
      }
    }

    return banner;
  };

  return (
    <>
      <div className="addressbar">
        <div className="addressbar__slide-in">
          <span>{handleBannerData()}</span>
        </div>
      </div>
    </>
  );
};

export default Banner;
